// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { upperFirst as _upperFirst } from 'lodash';

import { PLAYBOOK_STANZA } from '../../constants';
import FiltersIndicator from './FiltersIndicator';

import s from './index.module.scss';

export default function FiltersSideNav({ selectedTransformation, filtersPath, filters, scrollTo }) {
  return (
    <li
      className={cx(s.ellipsis, PLAYBOOK_STANZA.FILTERS === selectedTransformation ? s.current : null)}
      onClick={() => scrollTo({ opId: PLAYBOOK_STANZA.FILTERS })}
      data-test-id={`${filtersPath}InnerSideNav`}
    >
      <div>
        {_upperFirst(filtersPath)} Filters <FiltersIndicator filters={filters} />
      </div>
    </li>
  );
}

FiltersSideNav.propTypes = {
  selectedTransformation: PropTypes.string,
  filtersPath: PropTypes.string,
  filters: PropTypes.array,
  scrollTo: PropTypes.func,
};
